import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function MfNav() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [Category, setCategory] = useState('5946');
    const [Sheme, setSheme] = useState('26');
    const [loadingshow, setloadingshow] = useState(false);
    const [ShemeCodeHisto, setShemeCodeHisto] = useState('3868');
    const [DataDataMfHistorical, setDataMfHistorical] = useState([]);
    const [DataMfHoldingdropFundDivi, setDataMfHoldingdropFundDivi] = useState([]);
    const [DataMfHoldingdropCatDivi, setDataMfHoldingdropCatDivi] = useState([]);
    const [DateDividenddrop, setDateDividenddrop] = useState([]);
    const [DataMfDailyNav, setDataMfDailyNav] = useState([]);
    const [DatadropHistorical, setDatadropHistoricaldrop] = useState('1week');
    const [ShemeCode, setShemeCode] = useState('10645');
    const [type, settype] = useState('daily');

    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);
    const [DateNav, setDate] = useState("1week");
    const [valueschemename, setValueschemename] = useState([]);
    const [valuecategory, setValuecategory] = useState([]);
    const [valuecode, setvaluecode] = useState([]);
    const [valuecodehist, setvaluecodehist] = useState([]);
    let getDataHoldingdropFundDivi, getDataHoldingdropCatDivi,
        getDataHoldingDividend, getDataHoldingdropDate, getdataDailyNav, getdataHistoricalNav, getDatadropHistorical;
    let PageSize = 5;
    let navigate = useNavigate();

    useEffect(() => {
        setloadingshow(true);
        // document.getElementById('datenav').style.display = "none";
        const getUrlMfDropNav = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfDropNav}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropFund) => {
                getDataHoldingdropFundDivi = dataMHoldingdropFund.data;
                setDataMfHoldingdropFundDivi(getDataHoldingdropFundDivi);
                var schemename = getDataHoldingdropFundDivi[0].co_name;
                setValueschemename(schemename)
                setloadingshow(false);
                // console.log(getDataHoldingdropFundDivi, "getDataHoldingdropFundDivi")
            })
            .catch((error) => {
            });
        fetch(`${getUrlMfDropNav}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropCat) => {
                getDataHoldingdropCatDivi = dataMHoldingdropCat.data;
                setDataMfHoldingdropCatDivi(getDataHoldingdropCatDivi);
                var categoryname = getDataHoldingdropCatDivi[0].VCLASS;
                setValuecategory(categoryname)
                setloadingshow(false);
                // console.log(getDataHoldingdropCatDivi, "getDataHoldingdropCatDivi")
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfDropNav}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropDate) => {
                getDataHoldingdropDate = dataMHoldingdropDate.data;
                setDateDividenddrop(getDataHoldingdropDate);
                var codename = getDataHoldingdropDate[0].SCH_NAME;
                setvaluecode(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdropDate, "MfHoldingDropSheme")
            })
            .catch((error) => {
            });
        // alert(`${getUrlMfDropNav}/all/-`)
        fetch(`${getUrlMfDropNav}/all/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropDate) => {
                getDatadropHistorical = dataMHoldingdropDate.data;
                setDatadropHistoricaldrop(getDatadropHistorical);
                var schemenamehist = getDatadropHistorical[0].SCH_NAME;
                setvaluecodehist(schemenamehist)
                setloadingshow(false);
                // console.log(getDatadropHistorical, "getDatadropHistorical")
            })
            .catch((error) => {
            });

        if (type == 'daily') {
            // document.getElementById('datenav').style.display = "none";
            const getUrlMfDailyNav = BaseURL + "MFNavDaily";
            // alert(`${getUrlMfDailyNav}/${Category}/${Sheme}/${ShemeCode}/10`)
            fetch(`${getUrlMfDailyNav}/${Category}/${Sheme}/${ShemeCode}/8`)
                .then((response) => response.json())
                .then((dataDailyNav) => {
                    getdataDailyNav = dataDailyNav.data;
                    setDataMfDailyNav(getdataDailyNav);
                    setloadingshow(false);

                    // console.log(getdataDailyNav, "getdataDailyNav")
                })
                .catch((error) => {
                });
        }
        else {
            document.getElementById('datenav').style.display = "block";
            const getUrlMfHistNav = BaseURL + "MFNavHistorical";
            // alert(`${getUrlMfHistNav}/${ShemeCodeHisto}/${DateNav}/5`)
            fetch(`${getUrlMfHistNav}/${ShemeCodeHisto}/${DateNav}/8`)
                .then((response) => response.json())
                .then((dataHistNav) => {
                    getdataHistoricalNav = dataHistNav.data;
                    setDataMfHistorical(getdataHistoricalNav);
                    setloadingshow(false);

                    // console.log(getdataHistoricalNav, "getdataHistoricalNav")
                })
                .catch((error) => {
                }, []);

        }

    }, [Category, Sheme, ShemeCode, type, ShemeCodeHisto, DateNav])

    return (

        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>NAV</h4>
                    <span className="moreContent" onClick={() => { navigate("/MutualFund/Daily-NAV") }} tabIndex={0} > See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className='ipo-common mf-common nav-sc'>
                        <div id="divDividendDrop">
                            {type === "daily" ?
                                <div>
                                    <div className='holdings-select'>

                                        {/* aria-label="Fund House" */}
                                        <select aria-label="Fund House" onChange={(event) => setCategory(event.target.value)}>
                                            <option>Select Fund House</option>
                                            {DataMfHoldingdropFundDivi && DataMfHoldingdropFundDivi.map(
                                                ({ mf_cocode, co_name }) => (
                                                    <option value={mf_cocode} selected={valueschemename === co_name}>{co_name}</option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                    <div className='holdings-select'>

                                        {/* aria-label="Select Category" */}
                                        <select aria-label="Select Category" onChange={(event) => setSheme(event.target.value)}>
                                            <option>Select Category</option>
                                            {DataMfHoldingdropCatDivi && DataMfHoldingdropCatDivi.map(
                                                ({ VCLASSCODE, VCLASS }) => (
                                                    <option value={VCLASSCODE} selected={valuecategory === VCLASS}>{VCLASS}</option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                    <div className='holdings-select'>
                                        {/* aria-label="Select Scheme" */}
                                        <select aria-label="Select Scheme" onChange={(event) => setShemeCode(event.target.value)}>
                                            <option>Select Scheme</option>
                                            {DateDividenddrop && DateDividenddrop.map(
                                                ({ MF_SCHCODE, SCH_NAME }) => (
                                                    <option value={MF_SCHCODE} selected={valuecode === SCH_NAME}>{SCH_NAME}</option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div> :
                                <div>
                                    <div className='holdings-select' id="datenav">
                                        <select onChange={(event) => setDate(event.target.value)}>
                                            <option>Select Period</option>
                                            <option value="1week" selected={DateNav === "1week"}>1Week</option>
                                            <option value="1Month">1Month</option>
                                            <option value="1Year">1Year</option>
                                        </select>
                                    </div>
                                    <div className='holdings-select'>
                                        <select onChange={(event) => setShemeCodeHisto(event.target.value)}>
                                            <option value={(valuecodehist[0] != null) ? valuecodehist[0].valuecodehist : ''}>Select Fund House</option>
                                            {DatadropHistorical && DatadropHistorical.map(
                                                ({ MF_SCHCODE, SCH_NAME }) => (
                                                    <option value={MF_SCHCODE} selected={valuecodehist === SCH_NAME}>{SCH_NAME}</option>
                                                )
                                            )}
                                        </select>
                                    </div>

                                </div>}
                        </div>
                        <div>
                            <div className='nav-loser-toggle'>
                                <button id="btnGain" value="daily" className={(type === "daily") ? "active" : ''} onClick={(event) => { settype(event.target.value) }}>Daily</button>
                                <button id="btnLoose" value="historical" className={(type === "historical") ? "active" : ''} onClick={(event) => { settype(event.target.value) }}>Historical</button>
                            </div>
                        </div>


                        <div className='mf-table table-responsive gainer-table'>
                            <div className='newhigh-table table-responsive'>
                                <table className='table'>
                                    {(() => {
                                        if (type === "daily") {
                                            return (
                                                <><thead>
                                                    <tr>
                                                        <th className='text-left'>Scheme Name</th>
                                                        <th className='text-right'>Nav Date</th>
                                                        <th className='text-right'>NAV (Rs)</th>
                                                        <th className='text-right'>Repurchase Price (Rs)</th>

                                                    </tr>
                                                </thead>
                                                    {/* {(DataMfDailyNav === null) ? <h4 className="errormsgComNew">No Data Available !!!</h4> : ''} */}
                                                    {(DataMfDailyNav === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}

                                                    <tbody>
                                                        {(DataMfDailyNav != null) && DataMfDailyNav.map(
                                                            ({ sch_name, navdate, navrs, RepurchasePrice }) => (
                                                                <tr>
                                                                    <td className="text-left"><h6>{sch_name}</h6></td>
                                                                    <td className="text-right"> {navdate.split('T')[0]}</td>
                                                                    <td className="text-right">{navrs.toFixed(2)}</td>
                                                                    <td className="text-right">{RepurchasePrice.toFixed(2)}</td>
                                                                    {/* <td className="text-right"> {(BTHIGH != null) ? BTHIGH.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(B52HIGH != null) ? B52HIGH.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(B52HDATE != null) ? B52HDATE.split("T")[0] : 0}</td> */}
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else {
                                            return (
                                                <><thead>
                                                    <tr>
                                                        <th className='text-left'>Scheme Name</th>
                                                        <th className='text-right'>Nav Date</th>
                                                        <th className='text-right' >NAV (Rs)</th>
                                                        <th className='text-right'>Yearly Low(&#8377;)</th>
                                                    </tr>
                                                </thead>
                                                    {(DataDataMfHistorical === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                                    <tbody>
                                                        {(DataDataMfHistorical != null) && DataDataMfHistorical.map(
                                                            ({ sch_name, NAVDATE, NAVRS, NAVREPRICE, NAVSAPRICE }) => (
                                                                <tr>
                                                                    <td className="text-left"><h6>{sch_name}</h6></td>
                                                                    <td className="text-right"> {format(parseISO(NAVDATE.split('T')[0] != null ? NAVDATE.split('T')[0] : 0), 'dd-MMM-yyyy')}</td>
                                                                    <td className="text-right">{(NAVRS != null) ? NAVRS.toFixed(2) : 0}</td>
                                                                    <td className="text-right"> {(NAVREPRICE != null) ? NAVREPRICE.toFixed(2) : 0}</td>
                                                                    {/* <td className="text-right"> {(B52LDATE != null) ? B52LDATE.split("T")[0] : 0}</td> */}
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>)
                                        }
                                        // }
                                    })()}
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

        </>
    )
}

export default MfNav